import React, { useRef, useState } from "react";
import { JoinWaitlist } from "../../utils/api/JoinWaitlist";
import { FaRegCheckCircle } from "react-icons/fa";
import Star from "../star/Star";

const HeroSection = () => {
  const form = useRef();
  const [waitlisted, setWaitlisted] = useState(false);
  const waitlist = async (e) => {
    // console.log(form.current.phoneNumber.value);

    e.preventDefault();
    const joinWaitlist = await JoinWaitlist(form.current.phoneNumber.value);
    if (joinWaitlist) {
      setWaitlisted(true);
    }
    // console.log(joinWaitlist);
    // form.current.reset();
  };
  return (
    <div className="lg:w-[1300px] w-[361px] bg-white h-[589px]  rounded-[50px] lg:px-16 px-4  flex lg:flex-row justify-center items-center flex-col lg:gap-[10px] gap-9 lg:-mt-[158px] -mt-[210px] mx-auto manual-shadow overflow-hidden">
      <div className="flex flex-col lg:py-[101px] lg:gap-[52px] gap-8 lg:w-[562px] w-[329px] lg:items-start items-center relative">
        <div className="absolute lg:right-52 lg:top-20 right-14 top-0">
          <Star />
        </div>
        <div className="absolute lg:-right-10 lg:bottom-32 right-[300px] -bottom-6">
          <Star />
        </div>
        <div className="flex flex-col lg:gap-6 gap-3 items-center lg:items-start lg:justify-center justify-start lg:text-left text-center">
          <h2 className="font-semibold lg:text-5xl text-[28px]  lg:gap-4  flex flex-col text-[#364763]">
            <p>India’s First</p>
            <span className="text-[#E5204B]"> Zero Commission </span>
            <p>Hyperlocal Delivery</p>
          </h2>
          <h4 className="font-medium lg:text-2xl text-sm leading-[150%] text-[#606C80]">
            Fast, Affordable, and Rider-First
          </h4>
        </div>
        <div className=" flex lg:gap-6 gap-4 items-center justify-center">
          {/* <span className="flex justify-center items-center">
            <img src="/Images/assets/googleplay.svg" alt="" />
          </span>
          <span>
            <img src="/Images/assets/appstore.svg" alt="" />
          </span> */}
          <form
            className="lg:w-[418px] w-[278px] flex  items-center"
            ref={form}
            onSubmit={waitlist}
          >
            <input
              name="phoneNumber"
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              className="lg:border border-[0.67px] lg:p-5 p-4 border-[#E5204B] rounded-xl lg:w-[301px] w-[200px] lg:h-[60px] h-10  focus:outline-none lg:text-base text-[10px]"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              }}
              placeholder="Enter Phone Number"
            />
            <button
              type="submit"
              disabled={waitlisted}
              className={`bg-[#E5204B] ${
                waitlisted ? "lg:-ml-20 -ml-16" : "lg:-ml-10 -ml-8"
              } px-4 lg:h-[60px]  h-10 justify-center items-center flex rounded-xl text-[#F7F9FA] lg:text-lg text-xs font-semibold`}
            >
              {waitlisted ? (
                <div className="flex gap-1 justify-center items-center">
                  <FaRegCheckCircle /> We’ll notify you
                </div>
              ) : (
                "Join Waitlist"
              )}
            </button>
          </form>
        </div>
        <div className="flex lg:w-[166px] w-[124px] lg:-mt-8 -mt-4 lg:gap-3 gap-2 items-center justify-center">
          <h2 className="text-[#606C80] lg:text-base text-xs font-medium">
            powered by
          </h2>
          <div className="lg:w-16 w-12 flex items-center justify-center">
            <img src="/Images/assets/ONDC.svg" alt="" />
          </div>
        </div>
      </div>
      {/* <div className="lg:w-[593px] w-[321px] lg:h-[575px] h-[275px] relative -mb-12">
        <span className="absolute lg:top-[77px] top-2 lg:left-[150px] left-16  z-50 lg:w-[450px] w-56 lg:h-[603px] h-[352px]">
          <img src="/Images/phoneScreens/HomeScreen.svg" alt="" />
        </span>
        <span className="absolute lg:top-[147px] top-12 lg:left-[82px] left-8  z-30 lg:w-[250px] w-32 lg:h-[504px] h-[272px]">
          <img
            src="/Images/phoneScreens/ProgressScreen.svg"
            alt=""
            width={250}
            height={500}
          />
        </span>
      </div> */}
      <div className="lg:w-[593px] w-[321px] lg:h-[575px] h-[275px] relative -mb-12 ">
        <div className="lg:mt-0 -mt-10">
          <img src="/Images/assets/Hero.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
